"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _useGetValue = require("../../../../../hooks/useGetValue");
var _TemperatureFieldModule = _interopRequireDefault(require("../../../../../styles/components/DeviceTable/TemperatureField.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TemperatureField = _ref => {
  var _useSelector;
  let {
    thingPDIDDevice,
    displayNameId
  } = _ref;
  const {
    value,
    temperatureStatus = {},
    timestamp,
    unit
  } = (0, _useGetValue.useGetDeviceValueByParams)({
    displayNameId,
    thingPDIDDevice
  });
  const status = temperatureStatus.statusColor === _paulCorePackage.constants.colorStatus.optimal;
  const isCorrectTemperature = !isNaN(value) && value > 0 && value < 100;
  const time = (0, _react.useMemo)(() => timestamp ? (0, _moment.default)(timestamp).format('LT') : null, [timestamp]);
  const tUnits = ((_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues)) === null || _useSelector === void 0 || (_useSelector = _useSelector.Default) === null || _useSelector === void 0 ? void 0 : _useSelector.unit) || {};
  const tUnit = (0, _react.useMemo)(() => tUnits[unit], [tUnits, unit]);
  return (0, _react.useMemo)(() => isCorrectTemperature ? /*#__PURE__*/_react.default.createElement(_paulCorePackage.TooltipWrap, {
    text: time
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TemperatureFieldModule.default.table_cell, " ").concat(status ? '' : _TemperatureFieldModule.default.error_status)
  }, "".concat((+value).toFixed(1)).concat(tUnit || ''))) : /*#__PURE__*/_react.default.createElement("div", null, "--\xB0C"), [status, isCorrectTemperature, value, time, tUnit]);
};
var _default = exports.default = TemperatureField;